import { get } from "../../utils/object-helpers";

$ {
    const title = get(input, "title", {});
}

<if(state.sections.length)>
    <section class="str-about-policies about-layout--gutters">
        <h2 class="str-about-policies__title large-product-title section-header">
            <str-textual-display ...title />
        </h2>
        <for|section, idx| of=state.sections>
            $ {
                const type = get(section, 'action.params.policyTypes', '');
                const policy = state.policies[type];
            }
            <ebay-details on-toggle("fetchPolicies")
                open=section.isOpen
                text=section.title.textSpans[0].text
                key=idx>

                <input type="hidden" class="policy-type" value=type />
                <if(policy)>
                    <div data-testid=`${section.title.textSpans[0].text}-content`>
                        $ {
                            const splitText = policy.split("\n");
                        }
                        <for|text, idx| of=splitText>
                            <if(idx !== splitText.length - 1)>
                                ${text}
                                <br>
                            </if>
                            <else>
                                ${text}
                            </else>
                        </for>
                    </div>
                </if>
                <else>
                    <str-loading-spinner
                        ...input.page.modules.LOADING_SPINNER_MODULE
                        size="small"
                        isShow="true"/> 
                </else>
            </ebay-details>
        </for>
    </section>
</if>
